import { render, staticRenderFns } from "./DocumentsDownloads.vue?vue&type=template&id=72683108"
import script from "./DocumentsDownloads.vue?vue&type=script&lang=js"
export * from "./DocumentsDownloads.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports